/* istanbul ignore file */

import { Module } from 'vuex';

import { AppState } from '..';
import { prefixValues } from '@/helpers/util';
import { Achievement, AchievementYear, BagOffersResponse, Campaign, Reward, RewardOfferType } from '@/models';

export interface RewardModuleState {
  achievements: Achievement[];
  achievementYears: AchievementYear[];
  campaigns: Campaign[];
  rewards: Reward[];
  bagRewards: Reward[];
  offerTypes: RewardOfferType[];
  totalExtraPoints: number;
  shouldShowRefresh: boolean;
  unreachable: boolean;
}

const MUTATION_NAMES = {
  SET_REWARDS: 'setRewards',
  SET_BAG_OFFERS : 'setBagOffers',
  SET_EXTRAS_ACHIEVEMENTS: 'setExtrasAchievements',
  SET_EXTRAS_ACHIEVEMENT_YEARS: 'setExtrasAchievementYears',
  SET_EXTRAS_CAMPAIGNS: 'setExtrasCampaigns',
  SET_REWARDSTORE_OFFERTYPES: 'setRewardStoreOfferTypes',
  SET_TOTAL_EXTRA_POINTS: 'setTotalExtraPoints',
  SET_SHOULD_SHOW_REFRESH: 'setShouldShowRefresh',
  SET_UNREACHABLE: 'setUnreachable'
};

export const MUTATIONS = prefixValues(MUTATION_NAMES, 'reward/');

export function makeRewardModule(): Module<RewardModuleState, AppState> {
  return {
    namespaced: true,
    state: {
        achievements: [],
        achievementYears: [],
        campaigns: [],
        bagRewards: [],
        rewards: [],
        offerTypes: [],
        totalExtraPoints: 0,
        shouldShowRefresh: false,
        unreachable: false,
    },
    mutations: {
      [MUTATION_NAMES.SET_REWARDS](state, rewards: Reward[]) {
        state.rewards = rewards;
      },
      [MUTATION_NAMES.SET_BAG_OFFERS](state, bagRewards: Reward[]) {
        state.bagRewards = bagRewards;
      },
      [MUTATION_NAMES.SET_EXTRAS_ACHIEVEMENTS](state, achievements: Achievement[]) {
        state.achievements = achievements;
      },
      [MUTATION_NAMES.SET_EXTRAS_ACHIEVEMENT_YEARS](state, achievementYears: AchievementYear[]) {
        state.achievementYears = achievementYears;
      },
      [MUTATION_NAMES.SET_EXTRAS_CAMPAIGNS](state, campaigns: Campaign[]) {
        state.campaigns = campaigns;
      },
      [MUTATION_NAMES.SET_REWARDSTORE_OFFERTYPES](state, offerTypes: RewardOfferType[]) {
        state.offerTypes = offerTypes;
      },
      [MUTATION_NAMES.SET_TOTAL_EXTRA_POINTS](state, points: number) {
        state.totalExtraPoints = points;
      },
      [MUTATION_NAMES.SET_SHOULD_SHOW_REFRESH](state, value: boolean) {
        state.shouldShowRefresh = value;
      },
      [MUTATION_NAMES.SET_UNREACHABLE](state, value: boolean) {
        state.unreachable = value;
      },
    },
  };
}
